/**
 * applyTheme(themeId, themeVars)
 *
 * Writes the given theme's CSS variables onto the <html> element and sets
 * a `data-preset` attribute so CSS can target the active theme if needed.
 *
 * Safe to call many times. Cleans up vars from prior themes before applying.
 */
import { THEMES, resolveTheme } from "../registry";

let _appliedKeys = [];

export function applyTheme(themeId, presetId) {
    if (typeof document === "undefined") return;
    const html = document.documentElement;

    // Remove any vars we set last time
    _appliedKeys.forEach((k) => html.style.removeProperty(k));
    _appliedKeys = [];

    const themeVars = resolveTheme(themeId);
    Object.entries(themeVars).forEach(([key, value]) => {
        html.style.setProperty(key, value);
        _appliedKeys.push(key);
    });

    // Metadata for CSS selectors like [data-preset="preset_2"] { ... }
    html.setAttribute("data-theme", themeId || "classic_neon");
    if (presetId) html.setAttribute("data-preset", presetId);
}

/**
 * Ensure a sensible default theme is applied before the first fetch returns,
 * so the initial paint isn't unstyled.
 */
export function ensureDefaultTheme() {
    if (typeof document === "undefined") return;
    const html = document.documentElement;
    if (!html.getAttribute("data-preset")) {
        applyTheme("classic_neon", "preset_1");
    }
}

export { THEMES };
